import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";

export default function CookieModal() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const consent = Cookies.get("gdpr_consent");
    if (!consent) setOpen(true);
  }, []);

  const accept = () => {
    Cookies.set("gdpr_consent", "accepted", { expires: 365 });
    setOpen(false);
    console.log(
      "Cookies accepted. Initialize analytics or other services here."
    );
  };

  const decline = () => {
    Cookies.set("gdpr_consent", "declined", { expires: 365 });
    setOpen(false);
    console.log(
      "Cookies declined. No analytics or tracking will be initialized."
    );
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-2">
      <div className="bg-sdbodywhite dark:bg-gray-800 p-4 rounded-2xl shadow-xl max-w-md w-full space-y-4">
        <h2 className="text-xl font-bold text-gray-900 dark:text-gray-100">
          🍪 We Value Your Privacy
        </h2>
        <p className="text-gray-700 dark:text-gray-300">
          We use cookies to improve your experience. By clicking “Accept,” you
          agree to our{" "}
          <a href="/privacy-policy" className="underline text-blue-600">
            Privacy Policy
          </a>
          .
        </p>
        <div className="flex justify-end space-x-3">
          <button
            onClick={decline}
            className="px-4 py-2 bg-gray-300 hover:bg-gray-400 text-gray-900 rounded-lg transition"
          >
            Decline
          </button>
          <button
            onClick={accept}
            className="px-4 py-2 bg-sdorange hover:bg-sdorange text-black rounded-lg transition"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
